import { RouterModule, Routes } from '@angular/router';

import { PreloadSelectedModules } from '@core/*';
import { OfflineCompatibleAuthGuard } from './base/authentication/offline-compatible-auth.guard';
import { SettingsGuard } from './base/guards/settings.guard';
import { RoleGuard } from './base/guards/role.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'new', // Handled further by DefaultRedirectGuard.
  },
  {
    path: 'new',
    canActivate: [OfflineCompatibleAuthGuard, SettingsGuard], // Executes only once (either parent or child).
    canActivateChild: [OfflineCompatibleAuthGuard, RoleGuard, SettingsGuard], // Executed again for every child page.
    loadChildren: () => import('./pages/routes').then(mod => mod.ROUTES),
  },
  {
    path: '**', // Matches any unknown URL, including the removed URLs of the legacy QDrive app.
    redirectTo: 'new', // Handled further by DefaultRedirectGuard.
  },
];

/**
 * @deprecated See https://angular.io/guide/standalone-components#routing-and-lazy-loading
 */
export const AppRoutingModule = RouterModule.forRoot(routes, {
  /**
   * Preloads lazily loaded modules immediately after the main module was loaded.
   * This (potentially) reduces the loading time of the next page the user visits.
   * Technically not necessary because we already have the "installMode" in our
   * application manifest set to "prefetch", so when a new version of the application
   * is available all files are downloaded anyway. This functionality does not
   * work when developing on localhost though, so to prevent any issues when
   * debugging the offline flow during local development, we set the preload option.
   */
  preloadingStrategy: PreloadSelectedModules,
  bindToComponentInputs: true,
});
